import { useGetUserQuery } from '@/slices/user'

export const useIsMatchCriteriaEnabledForUser = () => {
  const { data: userData, isLoading: isUserLoading } = useGetUserQuery()

  const isMatchCriteriaEnabled = userData?.rmc?.matchCriteriaEnabled

  return {
    isMatchCriteriaLoading: isUserLoading,
    isMatchCriteriaEnabled,
  }
}
